// Gentle haptic feedback on supported devices (Android Chrome). iOS Safari ignores this.
export function haptic(ms = 10) {
  try {
    if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
      navigator.vibrate(ms);
    }
  } catch {
    /* noop */
  }
}
